export { default } from '@material-ui/core/Input'
export { default as InputBase } from '@material-ui/core/InputBase'
export { default as InputLabel } from '@material-ui/core/InputLabel'
export { default as InputAdornment } from '@material-ui/core/InputAdornment'
